class GeocodeAddressServiceError extends Error {
  constructor(name, message, opts) {
    super(message)
    this.name = `${this.constructor.name}${name}`
    Object.assign(this, opts)
  }
}

export default
class GeocodeAddressService {

  constructor(geocoder) {
    this.geocoder = geocoder
    this.geocodingAutoFilledFields = {}
  }

  geocodeAddress(address) {
    if (!this.geocoder) {
      return Promise.reject(new GeocodeAddressServiceError(
        'InputError',
        'Geocoder missing!'
      ))
    }

    const parsedAddress = this.parseAddressForGeocoding(address)
    if (!parsedAddress) {
      return Promise.reject(new GeocodeAddressServiceError(
        'ParseError',
        'Could not parse address'
      ))
    }
    return this.geocoder.geocode({
      address: parsedAddress,
    })
      .then((data) => {
        return this.handleReceivedLocation(data)
      })

  }

  parseAddressForGeocoding(data) {

    const name = this.getIsValidAddressPart(data, 'name', 8)
    const address = this.ensureAddress(data)

    if (!(name || (address.street && (address.zip || address.location)))) {
      const error = new Error('Not enough data for geocoding.')
      error.name = 'NotEnoughData'
      throw error
    }

    return `${name},
    ${address.street} ${address.street ? address.number : ''},
    ${address.zip} ${address.location}`
      // collapse multple whitespace
      .replace(/\s+/g, ' ')
      .replace(/undefined/g, '')
      // if string starts or ends with ", ", remove that
      .replace(/^,?\s*/g, '')
      .replace(/(?:,?\s*)+$/g, '')
      .replace(/(?:,\s*)+/g, ', ')

  }

  handleReceivedLocation(result) {
    if (!result) {
      return Promise.reject(new GeocodeAddressServiceError(
        'ParseError',
        'Could not parse address'
      ))
    }
    return result
  }

  getIsValidAddressPart(address, part, minLen) {
    if (this.geocodingAutoFilledFields[part]) {
      return ''
    }
    return (address && address[part] && address[part].length > minLen)
      ? address[part]
      : ''
  }

  ensureAddress(data) {

    if (data.address) {
      return {
        address: data.address,
        street: this.getIsValidAddressPart(data.address, 'street', 2),
        number: data.address.number,
        zip: this.getIsValidAddressPart(data.address, 'zip', 3),
        location: this.getIsValidAddressPart(data.address, 'location', 2)
      }
    }

    return {}

  }

}



// WEBPACK FOOTER //
// ./src/shared/services/GeocodeAddress.js